<template>
  <!-- App.vue -->
  <v-app>
    <!-- <v-app-bar app>
    </v-app-bar>-->
    <!-- Sizes your content based upon application components -->
    <v-content>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer color="blue-grey lighten-5" v-if="$route.meta.requiresAuth">
      <v-col class="text-left">
        Learning Central - create a ticket:
        <a
          href="mailto:support@centraladelaidelhn.zendesk.com"
        >support@centraladelaidelhn.zendesk.com</a> - v3.0
      </v-col>
      <v-col class="text-right">&copy; {{ new Date().getFullYear() }} Central Adelaide LHN</v-col>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { title: "Home", icon: "mdi-desktop-mac-dashboard", to: "/" }
      ]
    };
  },
  created () {
    document.title = "Learning Central - Statistics"
  }
};
</script>

<style scoped>
.v-footer {
  font-size: 0.7em;
}
.container {
  padding: 0;
}
</style>